import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';


@Component({
  selector: 'p1-lib-ui-elements-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class BadgeComponent {

  @Input()
  inline: boolean = false;

  @Input()
  dark: boolean = false;

}
